( function () {
	'use strict';

	function addEvidencesModal ( addEvidencesDirective ) {
		return angular.extend( {}, addEvidencesDirective[ 0 ], {
			'templateUrl'  : '/templates/components/evidences/pool/add-evidences-modal.html',
			'controller'   : 'addEvidencesModalCtrl',
			'controllerAs' : 'vm'
		} );
	}

	angular
		.module( 'app.components' )
		.directive( 'addEvidencesModal', addEvidencesModal );

	addEvidencesModal.$inject = [ 'addEvidencesDirective' ];
} )();
